import type { OverlayPreset } from "./types";

export const OVERLAY_PRESETS: OverlayPreset[] = [
	{ name: "Focus - Default (Black)", color: "#000000", opacity: 0.85 },
	{ name: "Focus - Dark Gray", color: "#333333", opacity: 0.9 },
	{ name: "Focus - Navy", color: "#000050", opacity: 0.9 },
	{ name: "Tint - Sepia", color: "#704214", opacity: 0.3 },
	{ name: "Tint - Soft Blue", color: "#ADD8E6", opacity: 0.4 },
	{ name: "Tint - Mint Green", color: "#98FF98", opacity: 0.4 },
	{ name: "Tint - High Contrast", color: "#000000", opacity: 0.9 },
	{ name: "Irlen - Light Aqua", color: "#AFEEEE", opacity: 0.5 },
	{ name: "Irlen - Peach", color: "#FFDAB9", opacity: 0.5 },
];
